// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__czmxE","label":"CategoryService_label__3m23Y","location":"CategoryService_location__2Gyyf"};